// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__kUoWA","Link":"Breadcrumbs_Link__10nzk"};